// ------------- import external dependencies -------------
import axios from "axios";

declare module 'axios' {
  export interface AxiosRequestConfig {
    apiVersion?: string;
  }
}

import moment from "moment";
import { clearStorage } from "../store/store";

// const { REACT_APP_BASE_URL } = process.env;
const VITE_BASE_URL = import.meta.env.VITE_BASE_URL;
export const instance = axios.create({
  baseURL: VITE_BASE_URL,
});
instance.interceptors.request.use(
  function (config: any) {
    if (config.apiVersion && config.baseURL) {
      config.baseURL = config.baseURL.replace(/\/v\d+$/, `/${config.apiVersion}`);
    }

    const token: string = localStorage.getItem("accessToken") ?? "";
    const userToken: string = localStorage.getItem("webAuthToken") ?? "";
    if (token != "") {
      // eslint-disable-next-line no-param-reassign
      config.headers["Authorization"] = `Bearer ${token}`;
      config.headers["Webauthtoken"] = userToken;
      const logInTimestamp = localStorage.getItem("logInTimestamp");
      if (logInTimestamp) {
        const currentTime = moment().format("YYYY-MM-DD HH:mm:ss");
        const difference = moment(currentTime).diff(logInTimestamp, "minutes");

        if (difference > 720) {
          localStorage.clear();
          const lastPath = window.location.pathname;
          if (lastPath) window.location.replace(`/?lastPath=${lastPath}`);
          return;
        } else {
          return config;
        }
      }
    }
    return config;
  },
  function (error) {
    console.log("error", error);
    return Promise.reject(error instanceof Error ? error : new Error(error));
  }
);

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.data[0]?.errorCode === "INVALID_SESSION_ID") {
      localStorage.clear();
      clearStorage();
    }
    return Promise.reject(error);
  }
);
